import lodash from 'lodash';
import Base from '../base.store';
import request from "../../../../utils/request";

const baseUrl = '/api/v1/transaction/sampling-products';
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        findAllCanRepeatSamplingProducts(context, { searchQuery, companyId, requestTypeKey,  config }) {
            const criteria = {
                select: [
                    '**',
                    'refCompanyProduct.**',
                    'refCompanyCountry1.**',
                    'refCompanyCountry2.**',
                    'refSamplingRequest.refSamplingRequestType.*',
                    'refSamplingRequest.refSamplingStatus.*',
                ],
                page: 0,
                size: 1000000,
                where: [
                    { name: 'refCompanyProduct.refCompany.id', type: 'UUID', operator: '=', value: companyId },
                    { name: 'refParent.id', type: 'UUID', operator: '=', value: null },
                    { name: 'refSamplingRequest.refSamplingStatus.key', type: 'String', operator: '=', value: 'Done'},
                    { name: 'refSamplingRequest.refSamplingRequestType.key', type: 'String', operator: '=', value: requestTypeKey },
                    { name: 'isActive', type: 'Boolean', operator: '=', value: true },
                    { name: 'refAcceptanceStatus.key', type: 'String', operator: '=', value: 'RejectCanRepeat' },
                ],
                children: [
                    {
                        name: 'analysiss', select: ['**'], page: 0, size: 10000,
                        where: [
                            { name: 'refLabResultStatus.key', type: 'String', operator: '=', value: 'RejectCanRepeat' },
                        ],
                        children: [
                            {
                                name: 'topics', select: ['**'], page: 0, size: 10000,
                                where: [
                                    { name: 'refTopicAnalysisStatus.key', type: 'String', operator: '=', value: 'Reject' },
                                ]
                            },
                        ]
                    },
                ]
            };

            if (searchQuery) {
                criteria.where.push({ name: 'samplingNo', type: 'String', operator: 'like', value: searchQuery },)
            }
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    return list
                });
        },
        getSumExportAmount(context, { data, config }) {
            return request.post(`${baseUrl}/get-sum-export-amount`, data, { ...config })
        },
    },
    mutations: {
        ...base.mutations
    }

};
